import axios from "axios"
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react"

import {
	FormControl,
	InputLabel,
	Input,
	FormHelperText,
	Alert,
} from "@mui/material"
import WebService from "../util/webService"
import { encodeParams, getAction } from "../util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import {
	Checkbox,
	FormGroup,
	FormControlLabel,
	Typography,
	Snackbar,
	TablePagination,
	TextField,
	withStyles,
	InputBase,
} from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "../components/FlatButton"
import useSnackbar from "../hooks/useSnackbar"
import MyTableHead from "../components/MyTableHead"
import useIndicator from "../hooks/useIndicator"
import Indicator from "../components/Indicator"
import MyDialog from "../components/MyDialog"
import useForm from "../hooks/useForm"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"

import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"
import { searchSchool } from "../util/helper"

const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
`

const StudentPage = () => {
	console.log("StudentPage rendering...")
	const inputRef = useRef()
	const defUrl = "/student"
	const dateFormat = "YYYY-MM-DD HH:mm:ss"
	const [detailScreen, set_detailScreen] = useState(false)

	const fields = [
		{
			field: "id",
			placeholder: "ID",
			type: "text",
			value: -1,
			visible: true,
			canSrch: true,
			selList: [],
		},
		{
			field: "name",
			placeholder: "이름",
			type: "text",
			value: "",
			visible: true,
			canSrch: true,
			selList: [],
		},
		{
			field: "schoolId",
			placeholder: "학교명",
			type: "auto",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "schoolName",
			placeholder: "학교명",
			type: "text",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "gdnPhone",
			placeholder: "보호자 전화 번호",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "grade",
			placeholder: "학년",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "className",
			placeholder: "반",
			type: "text",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "classNum",
			placeholder: "번호",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "remark",
			placeholder: "번호",
			type: "text",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
	]

	// const [fields, set_fields] = useState([...defFields])

	const gdnFields = [
		{ field: "name", placeholder: "성명" },
		{ field: "loginId", placeholder: "ID" },
		{ field: "phone", placeholder: "전화번호" },
		{ field: "phoneCertYn", placeholder: "인증여부" },
	]

	const regiLectureFields = [
		{ field: "title", placeholder: "강좌제목", table: "lecture" },
		{
			field: "statCode",
			placeholder: "신청상태",
			table: "regi",
			fn: (code) => findCode("SA12", code),
		},
		{
			field: "regCode",
			placeholder: "등록상태",
			table: "regi",
			fn: (code) => findCode("SB12", code),
		},
		{
			field: "statCode",
			placeholder: "강좌상태",
			table: "lecture",
			fn: (code) => findCode("SA09", code),
		},
	]

	const visibleColumns = fields.filter((col) => col.visible)
	const defRecord = {}
	fields.forEach((d) => {
		defRecord[d.field] = d.value
	})
	defRecord.schoolList = []
	const defTerms = {}
	fields
		.filter((col) => col.canSrch)
		.map((d) => d.field)
		.forEach((d) => (defTerms[d] = ""))
	const [record, set_record] = useState(defRecord)
	const [dataList, set_dataList] = useState([])

	const [skipPageReset, setSkipPageReset] = React.useState(false)
	const [openSnackbar, renderSnackbar] = useSnackbar()
	const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
	const dgHandler = useState(false)
	const [selIdx, set_selIdx] = useState(-1)
	const [pageNum, set_pageNum] = useState(0)
	const [pageSize, set_pageSize] = useState(10)
	const [totalCount, set_totalCount] = useState(0)
	const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: 10 })
	const [fontSize, set_fontSize] = useState(12)
	const termsRef = useRef({})
  const buttonRef = useRef(null)
	// redux
	const codeGroups = useSelector((state) => state.codeGroupReducer)
	const codes = useSelector((state) => state.codeReducer)
	const schools = useSelector((state) => state.schoolReducer)


	const onLoad = async () => {
		openIndicator()
		let url = defUrl
		let tempList
		let resp = await WebService.get(url, {
			pageNum: pageInfo.pageNum,
			pageSize: pageInfo.pageSize,
			terms: JSON.stringify(termsRef.current),
		})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			const totalCount = repMessage.totalCount
			set_totalCount(totalCount)
			records.forEach((r) => {
				r.isDetail = false
				r.guardian = { id: -1 }
				r.regiAndLectureList = []
			})

			// set_dataList(records)
			tempList = records
		}

		tempList.forEach((st) => {
			const found = schools.find((d) => d.id === st.schoolId)
			if (found) {
				st.schoolName = found.name
			}
		})

		set_dataList(tempList)

		closeIndicator()
	}

	const onDetail = async (id, guardianNum) => {
		// const newDataList = [...dataList]
		// const user = newDataList.find(d => d.id === id)

		// if(!user.isDetail) {
		//   const url = `${defUrl}/school/rltn`
		//   const resp = await WebService.get(url, {userId: id})

		//   if(resp.repCode === 'ack') {
		//     const resultMessage = JSON.parse(resp.repMessage)
		//     const records = JSON.parse(resultMessage.records)
		//     user.schoolRltnList = []
		//     records.forEach(r => {
		//       user.schoolRltnList.push(r)
		//     })
		//   }
		// }

		// user.isDetail = !user.isDetail
		// set_dataList(newDataList)

		const url = `${defUrl}/${id}`
		const resp = await WebService.get(url, { phone: guardianNum })

		if (resp.repCode === "ack") {
			const newDataList = [...dataList]
			const resultMessage = JSON.parse(resp.repMessage)
			const guardian = JSON.parse(resultMessage.guardian)
			const regiAndLectureList = JSON.parse(resultMessage.regiAndLectureList)
			const found = newDataList.find((d) => d.id === id)
			found.guardian = guardian
			found.regiAndLectureList = regiAndLectureList
			set_dataList(newDataList)
		}

		set_detailScreen(true)
		dgHandler[1](true)
	}

	const onDelete = async (id) => {
		const url = defUrl
		const resp = await WebService.delete(url, { id: id })
		if (resp.repCode === "ack") {
			onLoad()
			openSnackbar("삭제되었습니다.")
		} else {
			openSnackbar(resp.repMessage)
		}
	}

	const onCreate = () => {
		const now = moment().format(dateFormat)
		const newRecord = {
			...defRecord,
			regTime: now,
			uptTime: now,
			schoolRltnList: [],
		}
		newRecord.guardian = {}
		newRecord.regiAndLectureList = []
		set_record(newRecord)
		set_detailScreen(true)
		dgHandler[1](true)
	}

	const onSearch = () => {
		onLoad()
	}

	const onClear = () => {
		termsRef.current = {}
	}

	const handleChangePage = (event, newPage) => {
		set_pageInfo({ ...pageInfo, pageNum: newPage })
	}

	const handleChangeRowsPerPage = (event) => {
		const pageSize = parseInt(event.target.value, 10)
		set_pageInfo({ pageNum: 0, pageSize: pageSize })
	}

	const TablePaginationActions = (props) => {
		const theme = useTheme()
		const { count, page, rowsPerPage, onPageChange } = props

		const handleFirstPageButtonClick = (event) => {
			onPageChange(event, 0)
		}

		const handleBackButtonClick = (event) => {
			onPageChange(event, page - 1)
		}

		const handleNextButtonClick = (event) => {
			onPageChange(event, page + 1)
		}

		const handleLastPageButtonClick = (event) => {
			onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
		}

		return (
			<Box sx={{ flexShrink: 0, ml: 2.5 }}>
				<IconButton
					onClick={handleFirstPageButtonClick}
					disabled={page === 0}
					aria-label='first page'>
					{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
				</IconButton>
				<IconButton
					onClick={handleBackButtonClick}
					disabled={page === 0}
					aria-label='previous page'>
					{theme.direction === "rtl" ? (
						<KeyboardArrowRight />
					) : (
						<KeyboardArrowLeft />
					)}
				</IconButton>
				<IconButton
					onClick={handleNextButtonClick}
					disabled={page >= Math.ceil(count / rowsPerPage) - 1}
					aria-label='next page'>
					{theme.direction === "rtl" ? (
						<KeyboardArrowLeft />
					) : (
						<KeyboardArrowRight />
					)}
				</IconButton>
				<IconButton
					onClick={handleLastPageButtonClick}
					disabled={page >= Math.ceil(count / rowsPerPage) - 1}
					aria-label='last page'>
					{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
				</IconButton>
			</Box>
		)
	}

	const findCode = (codeGroupId, code) => {
		const found = codes
			.filter((d) => d.codeGroupId === codeGroupId)
			.find((d) => d.code === code)
		return found
	}

	const DgContent = () => {
		const onSubmit = async () => {

			const url = `${defUrl}`
			const data = activeRow
			const resp = await WebService.post(url, data)
			if (resp.repCode === "ack") {
				onLoad()
				handleChange()
				openSnackbar("저장되었습니다.")
			} else {
				openSnackbar("에러 발생")
			}
		}

		const validate = () => {}
		const [activeRow, errors, formLoading, handleChange, handleSubmit] =
			useForm({
				initialValues: { ...record },
				onSubmit: onSubmit,
				validate: validate,
			})
		const [emailError, setEmailError] = useState("")
		const [passwordState, setPasswordState] = useState("")
		const [passwordError, setPasswordError] = useState("")
		const [nameError, setNameError] = useState("")
		const [registerError, setRegisterError] = useState("")
		const [schoolList, set_schoolList] = useState([])
		// const Boxs = styled(Box)`
		//   padding-bottom: 40px !important;
		// `;

		const label = { inputProps: { "aria-label": "Checkbox demo" } }

		return (
			<Container component='main' maxWidth='lg'>
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
					}}>
					<Typography component='h1' variant='h5'>
						기본정보
					</Typography>
					<Boxs component='form' noValidate sx={{ mt: 3 }}>
						<FormControl component='fieldset' variant='standard' fullWidth>
							<Grid container spacing={2}>
								{fields.map((col, index) => {
									if (col.visible) {
										if (col.type === "select") {
											return (
												<Grid item xs={3} key={col.field}>
													<FormControl fullWidth>
														<InputLabel>{col.placeholder}</InputLabel>
														<Select
															required
															value={activeRow[col.field]}
															label={activeRow[col.placeholder]}
															name={col.field}
															onChange={handleChange}
															size='small'>
															{col.selList.map((l) => {
																return (
																	<MenuItem value={l.id}>{l.name}</MenuItem>
																)
															})}
														</Select>
													</FormControl>
												</Grid>
											)
										} else if (col.type === "auto") {
											return (
												<Grid item xs={3} key={col.field}>
													<Autocomplete
														disablePortal
														options={schoolList}
														name={col.field}
														value={schools.find(
															(r) => r.id === +activeRow[col.field]
														)}
														onInputChange={async (event, value, reason) => {
															if (reason === "input") {
																const records = await searchSchool(value)
																set_schoolList(records)
															}
														}}
														onChange={(e, v) => {
															activeRow[col.field] = v.id
														}}
														size='small'
														getOptionLabel={(option) => option.label}
														renderInput={(params) => (
															<TextField {...params} label='학교명' />
														)}
													/>
												</Grid>
											)
										} else {
											return (
												<Grid item xs={3} key={col.field}>
													<TextField
														size='small'
														required
														fullWidth
														name={col.field}
														label={col.placeholder}
														value={activeRow[col.field]}
														onChange={handleChange}
													/>
												</Grid>
											)
										}
									}
								})}
							</Grid>
						</FormControl>
						<FormHelperTexts>{registerError}</FormHelperTexts>
					</Boxs>

					<Typography component='h1' variant='h5'>
						보호자 정보
					</Typography>
					<Box sx={{ mt: 1, width: "100%" }}>
						<Grid container>
							{gdnFields.map((d) => {
								return (
									<Grid item xs={3}>
										{d.placeholder}
									</Grid>
								)
							})}
						</Grid>
						<Grid container>
							{gdnFields.map((d) => {
								return (
									<Grid item sx={{ fontSize: "0.9em" }} xs={3}>
										{activeRow.guardian[d.field]}
									</Grid>
								)
							})}
						</Grid>
					</Box>

					<Typography component='h1' variant='h5' sx={{ mt: 5 }}>
						수강(신청) 정보
					</Typography>
					<Box sx={{ mt: 1, width: "100%" }}>
						<Grid container>
							{regiLectureFields.map((d) => {
								return (
									<Grid item xs={12 / regiLectureFields.length}>
										{d.placeholder}
									</Grid>
								)
							})}
						</Grid>
						<Grid container>
							{activeRow.regiAndLectureList.map((rl) => {
								return regiLectureFields.map((col) => {
									if (col.fn && rl[col.table][col.field]) {
										const code = col.fn(rl[col.table][col.field])

										return (
											<Grid
												item
												xs={12 / regiLectureFields.length}
												sx={{ fontSize: "0.9em" }}>
												{code.name}
											</Grid>
										)
									} else {
										return (
											<Grid
												item
												xs={12 / regiLectureFields.length}
												sx={{ fontSize: "0.9em" }}>
												{rl[col.table][col.field]}
											</Grid>
										)
									}
								})
							})}
						</Grid>
					</Box>
					<Button
						variant='contained'
						color='primary'
						size='small'
						onClick={onSubmit}
						sx={{ mt: 10, width: 100 }}>
						저장
					</Button>
				</Box>
			</Container>
		)
	}

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };

	useEffect(() => {
		onLoad()
	}, [pageInfo])


  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);


  useEffect(() => {
		const size = window
			.getComputedStyle(inputRef.current, null)
			.getPropertyValue("font-size")

		set_fontSize(size)
	}, [])



	const dg_title = "학생 정보"
	const memo_DgContent = useMemo(() => {
		return <DgContent />
	}, [record, detailScreen])
	if (dataList != null) {
		return (
			<div ref={inputRef}>
				<MyDialog
					title={dg_title}
					component={memo_DgContent}
					dialogHandler={dgHandler}
					callback={() => {
						set_detailScreen(false)
					}}
				/>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "center",
					}}>
					<Typography component='h1' variant='h5' align={"center"}>
						학생 관리
					</Typography>
				</div>
				<div style={{ display: "flex", flexDirection: "row" }}>
					<Button
						variant='contained'
						color='primary'
						size='small'
						onClick={() => {
							onCreate()
						}}>
						생성
					</Button>
				</div>

				<div style={{ paddingTop: 20 }}>
					<MUITable>
						<MyTableHead>
							<TableRow>
								{fields.map((col, index) => {
									if (col.visible) {
										return (
											<TableCell key={index} size='small' >
												{col.placeholder}
												{col.canSrch ? (
													<Fragment>
														<br />
														<TextField
															label=''
															variant='outlined'
															size='small'
															inputProps={{
																style: {
																	fontSize: "0.875em",
																	padding: 5,
																	backgroundColor: "#fff",
																},
															}}
															onChange={(e) => {
                                termsRef.current[col.field] = e.target.value
															}}
														/>
													</Fragment>
												) : (
													<Fragment>
														<br />
														<br />
													</Fragment>
												)}
											</TableCell>
										)
									}
								})}
								<TableCell size='small'>
									<br />
									<FlatButton
                    ref={buttonRef}
										size='small'
										variant='contained'
										style={{ marginRight: 5 }}
										color='primary'
										onClick={onSearch}>
										검색
									</FlatButton>
									{/*<FlatButton*/}
									{/*	size='small'*/}
									{/*	variant='contained'*/}
									{/*	color='primary'*/}
									{/*	onClick={onClear}>*/}
									{/*	지우기*/}
									{/*</FlatButton>*/}
								</TableCell>
							</TableRow>
						</MyTableHead>
						<TableBody>
							{dataList.map((row, index) => {
								return (
									<Fragment key={index}>
										<TableRow
											onClick={() => {
												set_selIdx(index)
												set_record(dataList[index])
											}}>
											{fields.map((col, index2) => {
												if (col.visible) {
													return (
														<TableCell key={index2} size='small'>
															{row[col.field]}
														</TableCell>
													)
												}
											})}
											<TableCell size='small'>
												<FlatButton
													variant='outlined'
													size='small'
													style={{ marginRight: 5 }}
													onClick={() => onDetail(row.id, row.guardianNum)}>
													보기
												</FlatButton>
												{/*<FlatButton*/}
												{/*	variant='outlined'*/}
												{/*	color='error'*/}
												{/*	size='small'*/}
												{/*	onClick={() => onDelete(row.id)}>*/}
												{/*	삭제*/}
												{/*</FlatButton>*/}
											</TableCell>
										</TableRow>
									</Fragment>
								)
							})}
						</TableBody>
						<TableFooter>
							<TableRow>
								<TablePagination
									rowsPerPageOptions={[10, 20, 50, 100]}
									colSpan={visibleColumns.length + 1}
									count={totalCount}
									rowsPerPage={pageInfo.pageSize}
									page={pageInfo.pageNum}
									SelectProps={{
										inputProps: {
											"aria-label": "rows per page",
										},
										native: true,
									}}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
									ActionsComponent={TablePaginationActions}
									labelDisplayedRows={({ from, to, count }) => {
										// return '' + from + '-' + to + ' 개 ' + count
										return `${from} - ${to} of ${count}`
									}}
									labelRowsPerPage={"페이지당 갯수"}
								/>
							</TableRow>
						</TableFooter>
					</MUITable>

					{renderSnackbar()}
					{renderIndicator()}
					<dg_content />
				</div>
			</div>
		)
	}
}

export default StudentPage
